import { Box, Container, Button } from "@mui/material";
import { useCphDataContext } from "../hooks/useCphDataContext";
import FiltersAndIssueCards from "./FiltersAndIssueCards";
import Issue from "./Issue";

export default function CphLandingView() {
    const { showIssue, handleViewIssue, handleBack } = useCphDataContext();

    const BackButton = () => (
        <Box sx={{ mt: 2 }}>
            <Button variant="contained" size="small" onClick={handleBack}>
                Back To List
            </Button>
        </Box>
    );


    return (
        <Container disableGutters maxWidth={false} sx={{ width: '100%', height: '100%', p: 0, m: 0 }}>
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                    maxWidth: '100%',
                    mx: 0,
                    px: 0,
                    py: 0,
                }}
            >
                <Box sx={{ display: showIssue ? 'none' : 'block' }}>
                    <FiltersAndIssueCards onViewIssue={handleViewIssue} />
                </Box>
                <Box sx={{ display: showIssue ? 'block' : 'none' }}>
                    <BackButton />
                    <Issue />
                    <BackButton />
                </Box>
            </Box>
        </Container>
    );
}